import { FC, MouseEvent, useState } from 'react';
import { createPortal } from 'react-dom';

import { CustomButton } from '../../../../../../shared/uiComponents';
import { InfoSvg } from '../../../../../../shared/Assets/svgIcons';
import { TargetProperties } from '../../../../../../redux/API/ClientAPIHelpers/programTargetsProperties';
import Copy from './copyTarget';
import Move from './moveTarget';
import MasterOut from './masterOutTarget';
import Hold from './holdTarget';
import Delete from './deleteTarget';

interface TargetMenuProps {
	onDetailsClick?: () => void;

	target: TargetProperties;
}

const TargetMenu: FC<TargetMenuProps> = ({ target, onDetailsClick }) => {
	const [open, setOpen] = useState<boolean>(false);

	const toggleHandler = (e: MouseEvent) => {
		if (onDetailsClick) {
			e.stopPropagation();
			onDetailsClick();
		} else {
			e.stopPropagation();
			setOpen(!open);
		}
	};

	const closeHandler = () => setOpen(false);

	return (
		<>
			{onDetailsClick ? (
				<div className="targetActionButton" onClick={toggleHandler}>
					<InfoSvg />
				</div>
			) : (
				<>
					<CustomButton iconOnly={<InfoSvg />} buttonType="quaternary" sizeType="md" onClick={toggleHandler} />
					{open &&
						createPortal(
							<div className="targetMenuOverlay" onClick={closeHandler}>
								<div className="targetMenuDropdown" onClick={(e) => e.stopPropagation()}>
									<Copy id={target.id} programId={target.programId} />
									<Move id={target.id} programId={target.programId} />
									{target.status.id !== 2 && <MasterOut item={target} />}
									<Hold target={target} />
									<Delete id={target.id} programId={target.programId} />
								</div>
							</div>,
							document.body,
						)}
				</>
			)}
		</>
	);
};

export default TargetMenu;
